import { FETCH_LOGIN, FETCH_OTP, FETCH_REGISTER, FETCH_ACTION, IS_AUTHENTICATED } from "./types/authTypes";

const initialState = {
    login: [],
    otp: [],
    register: [],
    isAuthenticated : false,
    actiontype : {},
    user :{}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_LOGIN:
        console.log(initialState)
      return {
        ...state,
        login: action.payload
      };

    case FETCH_OTP:
      return {
        ...state,
        otp: action.payload
      };

      case FETCH_REGISTER:
        return {
          ...state,
          register: action.payload
        };

      case FETCH_ACTION:
        return {
          ...state,
          actiontype: action.payload
        };


        case IS_AUTHENTICATED : 
        return{
          ...state,
          isAuthenticated : action.payload ? true : false,
          user:action.payload
        }

    default:
      return state;
  }
}
